<div class="card">
  <div class="action-panel" id="button-container-id">
    <div class="d-flex flex-grow-1">
      <label class="d-flex align-items-center gap-3 mb-0">
        <app-toggle-button
          [switched]="showUnlodgedChanges"
          [disabled]="isLoading() || isCompanyLoading()"
          (switchBtn)="onChangeShowUnlodgedChanges($event)"
        />

        <span class="font-size-16 line-height-16 font-weight-bold">Display Changes</span>
      </label>
    </div>

    @if (validationErrorsQuantity) {

      <div ngbDropdown>
        <button
          ngbDropdownToggle
          type="button"
          class="btn btn-secondary d-flex align-items-center gap-2 "
          [disabled]="modalOpened() || isCompanyLoading()"
        >
          <i class="icon ic-alert-triangle-20 bg-red"></i>
          <span>Share Discrepancies | {{ validationErrorsQuantity }}</span>
          <i class="icon ic-chevron-down-20"></i>
        </button>

        <div ngbDropdownMenu class="common-dropdown-menu">
          @for (validationError of sharesValidationErrors.holdingCurrentMinusBalance; track validationError) {
            <button
              type="button"
              ngbDropdownItem
              [disabled]="isLoading() || isCompanyLoading()"
              (click)="onShowSecurityHoldingValidationError(validationError)"
            >
              <span>{{ validationError.message }}</span>
            </button>
          }

          @if (sharesValidationErrors.holdingCurrentMinusBalance.length && sharesValidationErrors.asicClassValidationErrors.length) {
            <app-divider margin="4px 0"/>
          }

          @for (holderClassValidationError of sharesValidationErrors.asicHolderRecordsValidationErrors; track holderClassValidationError) {
            <button
              type="button"
              ngbDropdownItem
              class="white-space-normal"
              [disabled]="isLoading() || isCompanyLoading()"
              (click)="onShowHolderClassMismatch(holderClassValidationError)"
            >
              <span>
                Discrepancy in {{ holderClassValidationError.shareholderName }} {{ holderClassValidationError.shareType }} shares
              </span>
            </button>
          }

          @if (sharesValidationErrors.asicClassValidationErrors.length && sharesValidationErrors.asicHolderRecordsValidationErrors.length) {
            <app-divider margin="4px 0"/>
          }

          @for (validationError of sharesValidationErrors.asicClassValidationErrors; track validationError) {
            <button
              type="button"
              ngbDropdownItem
              [disabled]="isLoading() || isCompanyLoading()"
              (click)="onShowClassMismatch(validationError)"
            >
              <span>Discrepancy in {{ validationError.class }} shares</span>
            </button>
          }

          @if (sharesValidationErrors.asicHolderRecordsValidationErrors.length && sharesValidationErrors.holdingHistoricalMinusBalance.length) {
            <app-divider margin="4px 0"/>
          }

          @for (validationError of sharesValidationErrors.holdingHistoricalMinusBalance; track validationError) {
            <button
              type="button"
              ngbDropdownItem
              [disabled]="isLoading() || isCompanyLoading()"
              (click)="onShowSecurityHoldingValidationError(validationError)"
            >
              <span>{{ validationError.message }}</span>
            </button>
          }
        </div>
      </div>

      <app-divider margin="0 8px" [vertical]="true"/>

    }

    <div
      *appHasRole="['Admin', 'Manager', 'Preparer']"
      ngbDropdown
      class="dropdown"
      [placement]="['bottom-end', 'bottom-start', 'top-start', 'top-end']"
    >
      <button
        ngbDropdownToggle
        id="add-transaction-dd"
        class="btn btn-primary d-flex align-items-center gap-2"
        [disabled]="isLoading() || modalOpened() || isCompanyLoading()"
      >
        <i class="icon ic-add-20"></i>
        <span class="flex-grow-1">Add Transaction</span>
        <i class="icon ic-chevron-down-20"></i>
      </button>

      <div
        ngbDropdownMenu
        aria-labelledby="add-transaction-dd"
        class="common-dropdown-menu dropdown-menu dropdown-menu-right"
      >
        @for (menuItem of addTransactionMenu; track $index) {
          @if ($last) {
            <app-divider margin="4px 0"/>
          }

          <button
            ngbDropdownItem
            [disabled]="isLoading() || modalOpened() || isCompanyLoading()"
            (click)="menuItem.action()"
          >
            <span>{{ menuItem.name }}</span>
          </button>
        }
      </div>
    </div>

    <div
      *appHasRole="['Admin', 'Manager', 'Preparer']"
      ngbDropdown
      class="dropdown"
      [placement]="['bottom-end', 'bottom-start', 'top-start', 'top-end']"
    >
      <button
        ngbDropdownToggle
        id="company-actions-dd-3"
        class="btn btn-primary d-flex align-items-center gap-2"
        [disabled]="isLoading() || modalOpened() || isCompanyLoading()"
      >
        <span>Form Actions</span>
        <i class="icon ic-select-20"></i>
      </button>

      <div
        ngbDropdownMenu
        aria-labelledby="company-actions-dd-3"
        class="common-dropdown-menu dropdown-menu dropdown-menu-right"
      >
        @for (item of sharesFormMenu; track $index) {
          <button
            ngbDropdownItem
            (click)="item.action()"
            [disabled]="isLoading() || modalOpened() || isCompanyLoading()"
          >
            <i class="icon ic-form-20"></i>

            <div class="document">
              <div class="title">{{ item.title }}</div>
              <div class="asic-form">{{ item.formName }}</div>
            </div>
          </button>
        }
      </div>
    </div>

    <div *appHasRole="['Admin', 'Manager', 'Preparer']">
      @if (checkedShares.length) {
        <div
          ngbDropdown
          class="dropdown"
          [placement]="['bottom-end', 'bottom-start', 'top-start', 'top-end']"
        >
          <button
            ngbDropdownToggle
            id="bulk-actions-dd"
            class="btn btn-primary d-flex align-items-center gap-2"
            [disabled]="modalOpened()"
          >
            <span>Actions</span>
            <i class="icon ic-select-20"></i>
          </button>

          <div
            ngbDropdownMenu
            aria-labelledby="bulk-actions-dd"
            class="common-dropdown-menu dropdown-menu dropdown-menu-right"
          >
            <div ngbDropdownItem (click)="exportSelectedTransactionsToXls()">
              <span>Export to xlsx</span>
            </div>

<!--            <div ngbDropdownItem (click)="exportSelectedTransactionsToCsv()">-->
<!--              <span>Export to csv</span>-->
<!--            </div>-->
          </div>
        </div>
      } @else {
        <app-button
          title="Export"
          btnColor="white"
          iconClass="icon ic-download-20"
          [isDisabled]="!clientSecurityTransaction.length || modalOpened() || isCompanyLoading()"
          (clickBtn)="exportTransactionsList(false, ExportTypeEnum.EXCEL)"
        />
      }
    </div>
  </div>

  @if (groupedShareRows.length) {
    <app-grid-client-side
      class="shares-grid"
      [rowSelection]="rowSelection"
      [rowData]="groupedShareRows"
      [colDefs]="$any(groupedColDefs())"
      [pageTitle]="pageTitle"
      [groupDisplayType]="groupDisplayType"
      [groupByOptions]="shareGroupByOptions"
      [detailRowAutoHeight]="detailRowAutoHeight"
      [masterDetail]="true"
      [detailCellRenderer]="detailCellRenderer"
      [detailCellRendererParams]="detailCellRendererParams"
      [rowClassRules]="groupedRowClassRules"
      [loading]="isLoading()"
      [excelStyles]="excelStyles"
      [defaultExcelExportParams]="excelExportParams"
      [defaultCsvExportParams]="csvExportParams"
      (gridReady)="onGridReady($event)"
      (select)="selectShares($event)"
      (selectGroupByOption)="selectGroupByOption($event)"
      (clearGroupByOption)="clearGroupByOption()"
    />
  } @else {
    <app-grid-client-side
      class="shares-grid"
      [rowSelection]="rowSelection"
      [rowData]="clientSecurityTransaction"
      [rowClassRules]="rowClassRules"
      [colDefs]="$any(colDefs())"
      [pageTitle]="pageTitle"
      [groupByOptions]="shareGroupByOptions"
      [loading]="isLoading()"
      [excelStyles]="excelStyles"
      [defaultExcelExportParams]="excelExportParams"
      [defaultCsvExportParams]="csvExportParams"
      (gridReady)="onGridReady($event)"
      (select)="selectShares($event)"
      (selectGroupByOption)="selectGroupByOption($event)"
      (clearGroupByOption)="clearGroupByOption()"
    />

    <app-divider margin="0 0 24px 0"/>

    <div class="chart-container">
      @if (shareBreakdownLabels.length && shareBreakdownSeries.length) {
        <app-donut-chart
          [name]="shareBreakdownTitle"
          [series]="shareBreakdownSeries"
          [labels]="shareBreakdownLabels"
        />
      }

      @if (shareTypeLabels.length && shareTypeSeries.length) {
        <app-donut-chart
          [name]="shareTypeTitle"
          [series]="shareTypeSeries"
          [labels]="shareTypeLabels"
        />
      }
    </div>
  }
</div>
